import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("missing"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") {
          setStatus("paid");
          clear();
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts < 5) { attempts++; setTimeout(poll, 2000); }
        else setStatus("pending");
      } catch {
        if (attempts < 5) { attempts++; setTimeout(poll, 2000); }
        else setStatus("error");
      }
    };
    poll();
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="mx-auto max-w-2xl px-6 py-32 text-center" data-testid="checkout-success">
      {status === "checking" && <h1 className="font-serif text-4xl tracking-tighter">Verificando tu pago…</h1>}
      {status === "paid" && (
        <>
          <p className="text-xs uppercase tracking-[0.3em] text-[#4A6B53]">Pago confirmado</p>
          <h1 className="font-serif text-5xl sm:text-6xl tracking-tighter mt-2">¡Gracias por tu compra!</h1>
          <p className="mt-4 text-[#5B605E]">Te enviamos los detalles a tu correo. Empezamos a preparar tu pedido con cariño.</p>
          <Link to="/catalogo" className="btn-primary mt-8 inline-flex">Seguir explorando</Link>
        </>
      )}
      {status === "pending" && <h1 className="font-serif text-4xl">Tu pago está procesándose. Te avisaremos por correo.</h1>}
      {status === "expired" && <h1 className="font-serif text-4xl">La sesión expiró. Intenta de nuevo.</h1>}
      {status === "error" && <h1 className="font-serif text-4xl">No pudimos verificar el pago. Contáctanos.</h1>}
      {status === "missing" && <h1 className="font-serif text-4xl">Falta el ID de sesión.</h1>}
    </div>
  );
}
